var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"10","height":"8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M.5 3.5l3 3.5 6-6","stroke":"#000"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }